import { DataMapStructure } from './data-map';

export const courseOutcomeDataMap: DataMapStructure = {
  low: { key: 'REPORTDATA.low', fallback: 'Low' },
  medium: { key: 'REPORTDATA.medium', fallback: 'Medium' },
  high: { key: 'REPORTDATA.high', fallback: 'High' },
  'very high': { key: 'REPORTDATA.very_high', fallback: 'Very High' },
  no: { key: 'REPORTDATA.no', fallback: 'No' },
  yes: { key: 'REPORTDATA.yes', fallback: 'Yes' },
  agree: { key: 'REPORTDATA.agree', fallback: 'Agree' },
  disagree: { key: 'REPORTDATA.disagree', fallback: 'Disagree' },
  print: { key: 'REPORTDATA.print', fallback: 'Print' },
  complete: { key: 'REPORTDATA.complete', fallback: 'Complete' },
  incomplete: { key: 'REPORTDATA.incomplete', fallback: 'Incomplete' },
  'not started': { key: 'REPORTDATA.not started', fallback: 'Not Started' },
  TRUE: { key: 'REPORTDATA.TRUE', fallback: 'True' },
  FALSE: { key: 'REPORTDATA.FALSE', fallback: 'False' },
  'no courses assigned': { key: 'REPORTDATA.No Courses Assigned', fallback: 'No Courses Assigned' },
};
